import Nullstack from 'nullstack';
export default function IconFloatRight({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-float-right",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    width: "6",
    height: "6",
    x: "14",
    y: "5",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "7",
    x2: "10",
    y2: "7"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "11",
    x2: "10",
    y2: "11"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "15",
    x2: "20",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "19",
    x2: "20",
    y2: "19"
  }), " ");
}